import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionVideoProperty = (
  target: CompatibilitySlide<'video'> | VotingSlide<'video'>,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
    case 'question':
      return staticContents.caption;
    case 'question_video_embed_url':
      return staticContents.url;
    case 'question_styled':
      return staticContents.styledTitle ?? {};
    default:
      return undefined;
  }
};
